const gql = (...values: (TemplateStringsArray | string)[]) => values.join(" ");

export default gql;
